const INITIAL_STATE = {
    healthData: null,
    loading: false,
    error: null,
};

export default function getHealthStatusReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "GET_HEALTH_STATUS_ACTION":
            return { ...state, loading: true, error: null };
        case "SUCCESSFULLY_GET_HEALTH_STATUS_DATA":
            return { ...state, loading: false, healthData: action.payload, error: null };
        case "GET_HEALTH_STATUS_ERROR":
            return { ...state, loading: false, error: action.payload };
        default:
            return { ...state };
    }
}
